import React from 'react'
import { ToolBar } from '../components/ToolBar';


export const TestScreen = (props) => {


    return (
        <>

            <ToolBar titulo={"Test"} hitos={[
                { titulo: "Inicio", enlace: "/" },
                { titulo: "Test", enlace: "#" }]} />
            <div id="kt_content_container" className="d-flex flex-column-fluid align-items-start container-xxl">
                <div className="content flex-row-fluid" id="kt_content">
                    <div className="row g-5 g-xl-10 mb-5 mb-xl-10">
                        <div className="col-xl-12">
                            <div className="card card-flush">
                                <div className="card-body pt-5">
                                    <div>
                                     
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}